import styled from 'styled-components';
import { darken } from 'polished';

import monitor_background from '../../../assets/monitor_background.svg';

export const Wrapper = styled.div`
  width: 100%;
  animation: 0.3s;
  background-color: #f5f5f5;
  padding: 15px 25px;

  height: auto;
  min-height: 100%;
  /* overflow-y: scroll; */

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.25);
  }

  @media (min-width: 768px) {
    width: calc(100% - 300px);
  }
`;

export const ButtonWraper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 60px;
  margin-bottom: 10px;

  button:not(.print_btn) {
    display: flex;
    align-items: center;
    justify-content: center;

    border: none;
    background-color: transparent;

    height: 35px;
    width: 150px;
    border-radius: 20px;

    font-size: 14px;
    font-weight: 500;
    color: #fff;

    letter-spacing: 1px;
    transition: all 0.35s ease-in-out;

    svg {
      margin-right: 10px;
    }
  }

  button.confirm-btn {
    background-color: #4caf50;
    border: 1px solid #2e7d32;

    margin-right: 25px;

    &:hover {
      background-color: #2e7d32;
      border: 1px solid #1b5e20;
    }
  }

  button.reject-btn {
    background-color: #e53935;
    border: 1px solid #c62828;

    &:hover {
      background-color: #c62828;
      border: 1px solid #b71c1c;
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 20px;

  > div {
    display: flex;
    flex-direction: column;

    div.principal_data {
      display: flex;

      h1 {
        font-size: 26px;
        color: #212121;
        margin-right: 15px;
      }

      span {
        display: flex;
        align-items: center;

        font-size: 17px;
        font-weight: 300;
        color: #424242;

        i {
          margin-left: 3px;
          font-weight: 500;
        }

        svg {
          margin: 0 5px;
        }
      }
    }

    div.fone {
      display: flex;
      align-items: center;
      margin-top: 5px;
      cursor: pointer;
      gap: 8px;

      span {
        font-size: 16px;
      }
    }
  }

  .whatsapp__icon {
    width: 24px;
    height: 24px;

    animation: rotate 1s infinite alternate;

    @keyframes rotate {
				from {
					transform: scale(1);
				}

				to {
					transform: scale(1.1);
				}

        from {
					transform: scale(1);
        }
    }
  }

  .container__icons {
    display: flex;
    flex-direction: column;
    position: relative;
  }
`;

export const FormaPagamentoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 20px 0px;
  flex-wrap: wrap;
`;

export const FormaPagamento = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);

  padding: 0 20px;
  height: 40px;

  span {
    font-size: 15px;
    font-weight: 500;
    color: #757575;

    strong {
      font-weight: 700;
      color: #666666;
    }
  }
`;

export const EnderecoWrapper = styled.div`
  display: flex;
  align-items: center;

  width: 100%;
  padding: 10px 20px;
  margin-bottom: 20px;

  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #fff;

  div.title-info-entrega {
    height: 30px;
    /* width: 125px; */
    padding: 5px 15px;
    margin-right: 30px;

    border: 1px solid #2e7d32;
    border-radius: 20px;
    background-color: #4caf50;

    span {
      font-weight: 600;
      color: #fff;
    }
  }

  p {
    display: flex;
    align-items: center;

    font-size: 16px;
    font-weight: 300;
    margin-bottom: 5px;

    color: #212121;
    letter-spacing: 1px;
  }

  span.referencia {
    display: block;
    margin-top: 10px;
    flex: 1;

    b {
      margin-right: 5px;
    }
  }

  div.container__referencia {
    display: flex;
    width: 100%;

    img {
      width: 24px;
      height: 24px;
    }
  }
`;

export const GoogleMapsImage = styled.img<{ haveAddress: boolean }>`
  filter: ${props => props.haveAddress ? 'initial' : `grayscale(1)`};
  cursor: ${props => props.haveAddress ? 'pointer' : `initial`};
`

export const PedidoWrapper = styled.div`
  width: 100%;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
`;

export const HeaderPedido = styled.div`
  height: 40px;

  background-color: #e0e0e0;
  border: 1px solid #c9c9c9;
  border-bottom: none;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`;

export const ListProdutosWrapper = styled.div`
  border-top: none;
`;

export const ProdutoPedido = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  min-height: 60px;
  padding: 10px 20px;

  background-color: #fff;
  border-top: 1px solid #c9c9c9;
  color: #212121;
  font-size: 16px;

  &.observacao {
    div.obs-description {
      font-size: 16px;

      span {
        font-weight: 500;
        color: #b71c1c;
      }

      p {
        font-weight: 400;
        color: #b71c1c;
      }
    }
  }

  &.complemento {
    min-height: 40px;
    padding-bottom: 15px;

    div {
      font-size: 15px;

      span {
        display: flex;
        align-items: center;
        color: #757575;
        font-weight: 300;

        svg {
          color: #757575;
        }
      }

      p {
        font-weight: 300;
      }
    }

    span.preco-produto {
      font-size: 15px;
      white-space: nowrap;
    }

    padding-left: 50px;
    padding-top: 0;
    border-top: none;
  }

  div {
    display: flex;
    align-items: center;

    span {
      margin-right: 25px;
      font-weight: 300;
    }

    p {
      letter-spacing: 1px;
      font-weight: 500;
    }
  }

  span.preco-produto {
    font-weight: 300;
  }

  svg {
    margin-right: 14px;
    color: #9e9e9e;
  }
`;

export const CaixaClosedNotice = styled.div`
  padding: 15px 25px;
  color: #212121;

  h1 {
    margin-bottom: 100px;
  }

  div {
    height: 300px;
    width: 100%;

    background: url(${monitor_background}) no-repeat center right;
    background-size: contain;
  }
`;

export const ObservacoPedido = styled.div`
  display: flex;
  flex-direction: column;

  min-height: 40px;

  background-color: #fff;
  border: 1px solid #e0e0e0;
  margin-bottom: 15px;
  padding: 10px 20px;

  border-radius: 6px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);

  h3 {
    display: flex;
    align-items: center;

    svg {
      margin-right: 10px;
    }
  }

  div {
    margin: 10px 0 5px;

    span {
      font-size: 15px;
    }
  }
`;

export const ModalWrapper = styled.div`
  width: 400px;
  background: #fff;
  border-radius: 6px;
  padding: 10px 15px 15px;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    button {
      background: transparent;
      border: none;
    }
  }

  main {
    display: flex;
    align-items: center;
    justify-content: center;

    button:not(.print_btn) {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #e53935;
      color: #fff;

      font-size: 14px;

      padding: 7px 12px;
      border-radius: 40px;
      border: none;

      svg {
        margin-right: 7px;
      }

      &:hover {
        background: ${darken(0.025, '#e53935')};
      }
    }

    button + button {
      margin-left: 15px;
    }
  }
`;

export const ContainerCompartilhar = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  margin: 7px 12px;

  img {
    width: 20px;
    height: 20px;
    filter: ${props => props.isOpen ? 'initial' : 'grayscale(1)'};

    &:hover {
      filter: initial;
    }
  }

  .compartilhar__conteudo {
    display: ${props => props.isOpen ? 'initial' : 'none'};
    position: absolute;
    padding: 5px;
    background: #fff;
    transform: translateX(-100%);
    box-shadow: 1px 1px 5px rgb(0 0 0 / 20%);
    border-radius: 4px;
  }

  .compartilhar__copia__pedido {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 2px 5px;
    border: 1px solid transparent;
    transition: 0.2s;
    cursor: pointer;

    &:hover {
      border: 1px solid #777;
      border-radius: 4px;
      background: #ddd;
    }

    p {
      font-size: 10px;
      font-weight: 500;
      white-space: nowrap;
    }
  }

  .compartilhar__whatsapp {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    padding: 2px 5px;
    border: 1px solid transparent;
    transition: 0.2s;
    cursor: pointer;


    div {
      display: flex;
      gap: 5px;
      align-items: center;
    }

    p {
      font-size: 10px;
      font-weight: 500;
      white-space: nowrap;
    }

    input {
      width: 100%;
      height: 32px;
      padding: 0 10px;
      border-radius: 4px;
      border: 1px solid #bdbdbd;
      color: #424242;
      font-size: 14px;
    }

    &:hover {
      border: 1px solid #777;
      border-radius: 4px;
      background: #ddd;
    }
  }

  .compartilhar__whatsapp__entrada {
    position: relative;

    img {
      position: absolute;
      right: 5px;
      width: 16px;
      height: 16px;
      filter: grayscale(1);
      cursor: pointer;

      &:hover {
        filter: initial;
      }
    }
  }
`
